import React from 'react';
import translate from '../translate';
import { useSelector } from 'react-redux';

function WhyChooseUs() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'whyChooseUs';

    return (
        <div className="wcu-section pt-130 pb-130">
        <div className="container">
            <div className="row">
                <div className="col-xl-6">
                    <div className="section-heading section-heading__style-2">
                        <span className="sub-heading">{translate(componentName, 'subHeading', language)}</span>
                        <h2 className="heading">{translate(componentName, 'heading', language)}</h2>
                        <p>{translate(componentName, 'description', language)}</p>
                    </div>
                    <div className="wcu-box-wrapper mt-65">
                        <div className="wcu-box">
                            <div className="icon">
                                <img src="assets/img/icons/wcu-1.html" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title">{translate(componentName, 'expertiseTitle', language)}</h4>
                                <p>{translate(componentName, 'expertiseDescription', language)}</p>
                            </div>
                        </div>
                        <div className="wcu-box">
                            <div className="icon">
                                <img src="assets/img/icons/wcu-2.html" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title">{translate(componentName, 'clientCentricTitle', language)}</h4>
                                <p>{translate(componentName, 'clientCentricDescription', language)}</p>
                            </div>
                        </div>
                        <div className="wcu-box">
                            <div className="icon">
                                <img src="assets/img/icons/wcu-3.html" alt=""/>
                            </div>
                            <div className="content">
                                <h4 className="title">{translate(componentName, 'transformationTitle', language)}</h4>
                                <p>{translate(componentName, 'transformationDescription', language)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="wcu-img">
                        <img src="assets/img/bg/wcu-1.html" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default WhyChooseUs;